import { Box, Button, Stack, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { BaseModal } from "component/Modal/BaseModal";
import LoadingButton from "component/Button/LoadingButton";
import { dayMap } from "./helper";
import { ScheduleItem } from "types/response/schedule";
import { formatTime } from "utils/time";

type DeleteModalProps = {
  schedule: ScheduleItem;
  mapName: string;
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  isDeleting: boolean;
};

export const ScheduleDeleteModal = ({
  schedule,
  mapName,
  open,
  onClose,
  onDelete,
  isDeleting,
}: DeleteModalProps) => {
  const displayTime = formatTime(schedule.hour, schedule.minute);
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon color="error" sx={{ fontSize: 28 }} />
          <Typography>スケジュール削除</Typography>
        </Box>
      }
      children={
        <>
          <Box>
            <Box mb={2}>
              <Typography>次のスケジュールを削除しますか？</Typography>
            </Box>
            <Box>
              <Typography variant="h4">{`${
                dayMap[schedule.dayOfWeek]
              } ${displayTime}`}</Typography>
              <Typography variant="h6" color="text.secondary">
                {mapName}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                {schedule.scheduleName}
              </Typography>
            </Box>
          </Box>
        </>
      }
      actions={
        <Stack direction={"row"} spacing={2}>
          <Button
            disabled={isDeleting}
            variant="outlined"
            onClick={onClose}
            autoFocus
          >
            キャンセル
          </Button>
          <LoadingButton
            isLoading={isDeleting}
            color="error"
            variant="contained"
            onClick={onDelete}
            sx={{ minWidth: "120px" }}
          >
            削除
          </LoadingButton>
        </Stack>
      }
    />
  );
};
